import * as Yup from 'yup'

export const MAX_SIZE = 1024 * 1024 * 3

export const RfqSchema = Yup.object().shape({
  orderQuantity: Yup.number()
    .typeError('rfq:Error.Value_Must_Number')
    .moreThan(49, 'rfq:Error.Quantity_Minimum')
    .required('rfq:Error.Order_Qty_Required'),
  file: Yup.mixed().test('fileSize', 'rfq:Error.File_Too_Large', (file) => {
    if (!file) return true
    return file && file.size <= MAX_SIZE
  }),
  isCustomOrder: Yup.boolean(),
  fabricName: Yup.string().when('isCustomOrder', {
    is: true,
    then: Yup.string().required('rfq:Error.Fabric_Name_Required'),
  }),
  fabricType: Yup.string().when('isCustomOrder', {
    is: true,
    then: Yup.string().required('rfq:Error.Fabric_Type_Required'),
  }),
  notes: Yup.string().required('rfq:Error.Notes_Required'),
})
